import * as actionTypes from '../consts/actionTypes';

export const getFooterByPageType = payload => (dispatch, getState) => {
    dispatch({
        type: actionTypes.getFooterByPageType,
        payload,
    });
};
